import { Datatable } from '@wyz/ui';
import * as React from 'react';
import { Trans, useI18n } from '~/common/context';

export function DatatableProvider(props: React.PropsWithChildren) {
  const { t } = useI18n();
  return (
    <Datatable.ConfigurationProvider
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      translate={t as any}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Trans={Trans as any}
      translations={{
        emptyMessageText: (
          <Trans i18nKey='app.purchase.search_page.no_results' />
        ),
        exportBtn: <Trans i18nKey='app.common.datatable.csv_export_btn' />,
        searchBtn: <Trans i18nKey='app.common.buttons.search' />,
        resetBtn: <Trans i18nKey='app.common.buttons.delete' />,
        selectedLabel: (args) => (
          <Trans i18nKey='app.common.datatable.selected_label' values={args} />
        ),
        selectAllLabel: (
          <Trans i18nKey='app.common.datatable.select_all_label' />
        ),
        pagination: {
          showingResult: (args) => (
            <Trans
              i18nKey='app.common.datatable.pagination.showing_result'
              values={args}
            />
          ),
          itemsPerPageSelect: (
            <Trans i18nKey='app.common.datatable.pagination.items_per_page_select' />
          ),
          itemsPerPageValue: (count) => (
            <Trans
              i18nKey='app.common.datatable.pagination.items_per_page_select_value'
              values={{ count }}
            />
          ),
          next: <Trans i18nKey='app.common.datatable.pagination.next' />,
          previous: (
            <Trans i18nKey='app.common.datatable.pagination.previous' />
          ),
          page: (args) => (
            <Trans
              i18nKey='app.common.datatable.pagination.page'
              values={args}
            />
          ),
        },
      }}
    >
      {props.children}
    </Datatable.ConfigurationProvider>
  );
}
